export const companies = [
    {code: "HSKY", name: "Husky Energy"},
    {code: "EMBR", name: "Ember Resources"},
    {code: "CNRL", name: "CNRL"},
    {code: "TAQN", name: "Taqa North"},
    {code: "PERP", name: "Perpetual Energy"}
]